import { Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import styled from '@emotion/styled';
import { css, SerializedStyles } from '@emotion/core';

import { ICustomTheme } from 'interfaces';

type Theme = {
  theme?: ICustomTheme;
};

export const progressStyles = (theme: ICustomTheme) =>
  createStyles({
    bar: {
      backgroundSize: '12px 12px',
      backgroundImage: `linear-gradient(
      45deg,
      ${theme.colors.paletteFromBO.main} 25%,
      ${theme.colors.burgundyRed.red2} 25%,
      ${theme.colors.burgundyRed.red2} 50%,
      ${theme.colors.paletteFromBO.main} 50%,
      ${theme.colors.paletteFromBO.main} 75%,
      ${theme.colors.burgundyRed.red2} 75%,
      ${theme.colors.burgundyRed.red2} 100%
    )`,
      borderRadius: '0 12px 12px 0',
    },
    root: {
      backgroundSize: '12px 12px',
      backgroundImage: `linear-gradient(
      45deg,
      ${theme.colors.paletteFromBO.primary} 25%,
      ${theme.colors.orange.light} 25%,
      ${theme.colors.orange.light} 50%,
      ${theme.colors.paletteFromBO.primary} 50%,
      ${theme.colors.paletteFromBO.primary} 75%,
      ${theme.colors.orange.light} 75%,
      ${theme.colors.orange.light} 100%
    )`,
      height: 12,
      marginRight: -3,
    },
  });

export const cssCard = {
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
};

export const cssResultContainer = (theme: ICustomTheme): SerializedStyles =>
  css({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3, 3, 4),
  });

export const Result = styled(Typography)<Theme>(({ theme }) => ({
  color: theme.colors.paletteFromBO.primary,
  fontSize: theme.typography.h2.fontSize,
  [theme.breakpoints.down('xs')]: {
    fontSize: theme.typography.h4.fontSize,
  },
}));

export const SubGoal = styled('sub')<Theme>(({ theme }) => ({
  color: theme.palette.grey[700],
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  [theme.breakpoints.down('xs')]: {
    fontSize: theme.typography.caption.fontSize,
  },
}));

export const Unit = styled(Typography)<Theme>(({ theme }) => ({
  color: theme.colors.grey.main,
  fontSize: theme.typography.body1.fontSize,
  [theme.breakpoints.down('xs')]: {
    fontSize: theme.typography.caption.fontSize,
  },
}));

export const UserName = styled('span')<Theme>(({ theme }) => ({
  fontSize: theme.typography.body1.fontSize,
  [theme.breakpoints.down('xs')]: {
    fontSize: theme.typography.caption.fontSize,
  },
}));
